import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import uniqolor from "uniqolor";
export default {
  data: function data() {
    return {
      show: {
        cc: false,
        bcc: false
      }
    };
  },
  methods: {
    handleView: function handleView(att) {
      var viewer = this.$el.querySelector(".viewer-".concat(att.file_id)).$viewer;
      viewer.show();
    },
    saveAsRead: function saveAsRead() {
      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
      new KivaProxy({
        endpoint: 'inbox/thread'
      }).update({
        record_id: this.id,
        message_status: status
      }).then(function (response) {
        //debugger 
      });
    },
    getFirstChars: function getFirstChars(name) {
      if (name) {
        var ex = name.split(" ");
        var f = name.charAt(0);
        var all = ex.length - 1;
        var l = "";
        if (f == '"') {
          f = name.charAt(1);
        }
        if (all != 0 && ex[all]) {
          l = ex[all].charAt(0);
        }
        return (f + l).toLocaleUpperCase("tr-TR");
      }
      return "--";
    },
    optimizeMessage: function optimizeMessage(message) {
      if (message) {
        var result2 = '';
        var m2 = message.split("<table");
        if (m2 && m2[0]) {
          result2 = m2[0];
          var a = 0;
          m2.forEach(function (element) {
            if (a > 0) {
              var inImg = element.split("/table>");
              inImg[0] = inImg[0] + "/table></figure";
              var html = inImg.join(">");
              result2 += "<figure><table" + html;
            }
            a++;
          });
        } else {
          result2 = message;
        }
        var m1 = result2.split("<img");
        var result = m1[0];
        var i = 0;
        var ls = [];
        ls.push({
          html: m1[0]
        });
        m1.forEach(function (element) {
          if (i > 0) {
            if (element) {
              var inImg = element.split(">");
              var src1 = inImg[0].split('src="');
              var src2 = src1[1].split('"');
              var img = src2[0].replace("https://cloud.kiva.app", process.env.VUE_APP_BASE_URL);
              var width1 = inImg[0].split('src="');
              var width2 = width1[1].split('"');
              img = img.replaceAll("amp;", '');
              ls.push({
                img: img,
                width: width2[0]
              });
              inImg.shift();
              var html = inImg.join(">");
              ls.push({
                html: html
              });
              // @click="handleView(att)"
              // result += '<figure><div ref="viewer-images" class="viewer-images viewer-12'+i+'" v-on:click="handleView()"  v-viewer> <img loading="lazy" style="cursor: pointer;width: 100%; height: auto;" class="" ' + html;
            }
          }

          i++;
        });
        return ls;
      }
    },
    getTruncatedText: function getTruncatedText(str) {
      if (str) {
        var str_arr = str.split("}");
        var total = str_arr.length;
        str = str_arr[total - 1];
        str = str.replace(["&nbsp;", "&#8217;"], ["", "'"]);
        if (str) {
          if (str.length > 100) {
            return "".concat(str.substr(0, 97), "...");
          } else {
            return str;
          }
        }
      } else {
        return str;
      }
    },
    getColor: function getColor(id) {
      var c = uniqolor(id);
      return c.color;
    },
    saveLabels: function saveLabels(threadId, labels) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var labelId, all_labels_Id, search, jsearch;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              labelId = null;
              all_labels_Id = [];
              if (labels && labels[0]) {
                labels.forEach(function (k, i) {
                  if (k) {
                    // önce yeni olanların kaydı
                    if (typeof k == "string") {
                      new KivaProxy({
                        endpoint: 'inbox/thread_label'
                      }).create([{
                        label_name: k
                      }]).then(function (data) {
                        labelId = data.record.record_id;
                        all_labels_Id.push(labelId);
                      }).catch(function (err) {});
                    } else if (typeof k == "number") {
                      labelId = k;
                      all_labels_Id.push(labelId);
                    }

                    // 2.aşama da yeni atananların kontrolü ve  kaydı
                    var search2 = {
                      thread: ["=", threadId],
                      thread_label: ["=", labelId]
                    };
                    var jsearch2 = JSON.stringify(search2);
                    new KivaProxy({
                      endpoint: 'inbox/thread_labels'
                    }).setFilters(jsearch2).all().then(function (response) {
                      // eğer yeni atanmışsa kaydediliyot.
                      if (!response.records[0]) {
                        new KivaProxy({
                          endpoint: 'inbox/thread_labels'
                        }).create([{
                          thread_label: labelId,
                          thread: threadId
                        }]).then(function (data) {}).catch(function (err) {});
                      }
                    });
                  }
                });
              }
              // Son aşamada daha önce var olup şimdi olmayanlar siliniyor.
              search = {
                thread: ["=", threadId]
              };
              jsearch = JSON.stringify(search);
              new KivaProxy({
                endpoint: 'inbox/thread_labels'
              }).setFilters(jsearch).all().then(function (response) {
                var all = response.records;
                all.forEach(function (k) {
                  if (all_labels_Id && all_labels_Id.includes(k.thread_label.value)) {} else {
                    new KivaProxy({
                      endpoint: 'inbox/thread_labels'
                    }).destroy(k.record_id);
                  }
                });
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fillThreadForm: function fillThreadForm(contact, model) {
      if (!model) {
        model = this.model;
      }
      // console.log("contact",contact)
      if (contact) {
        var me = _objectSpread({}, this.$store.state.users.CURRENT_USER);
        model.senderPhone = me.phone;
        model.senderName = contact.target_label ? contact.target_label : contact.label;
        model.senderEmail = contact.target_email ? contact.target_email : contact.email;
        model.contactName.recordId = contact.target_record_id;
        model.contactName.label = contact.target_email ? contact.target_email : contact.label ? contact.label : contact.email;
        model.contactName.name = contact.target_label ? contact.target_label : contact.label;
        model.contactName.email = contact.target_email ? contact.target_email : contact.email;
        model.accountName.recordId = contact.accountName ? contact.accountName.value : '';
        model.accountName.label = contact.accountName ? contact.accountName.label : '';
      }
    },
    showAdditionalEmailFields: function showAdditionalEmailFields() {
      if (this.model.cc && this.model.cc[0]) {
        this.show.cc = true;
      }
      if (this.model.bcc && this.model.bcc[0]) {
        this.show.bcc = true;
      }
    }
  },
  watch: {
    value: function value() {
      this.showAdditionalEmailFields();
    }
  }
};